import type { MotionProps } from 'framer-motion';
import {
  buildHiddenVariant,
  buildVisibleVariant,
} from '@/components/animations';

const Y_OFFSET = 50;

const hidden = buildHiddenVariant({ y: Y_OFFSET });
const visible = buildVisibleVariant();

/*
 * Wrapper Element Animations
 */
export const wrapperElementMotionProps: MotionProps = {
  initial: 'hidden',
  variants: {
    hidden,
    visible: buildVisibleVariant({
      transition: {
        staggerChildren: 0.2,
      },
    }),
  },
  viewport: { once: true },
  whileInView: 'visible',
};

/*
 * Button Animations
 */
export const buttonMotionProps: MotionProps = {
  variants: {
    hidden,
    visible,
  },
  whileHover: { scale: 1.05 },
  whileTap: { scale: 0.95 },
};

/*
 * Paragraph Animations
 */
export const paragraphMotionProps: MotionProps = {
  variants: {
    hidden,
    visible,
  },
};
